import { render, staticRenderFns } from "./AppOccupationalMedicine.vue?vue&type=template&id=8de59c02&"
import script from "./AppOccupationalMedicine.vue?vue&type=script&lang=js&"
export * from "./AppOccupationalMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports